import QuestionnaireApproval from './QuestionnaireApproval'

export default QuestionnaireApproval
